import React from "react";
import PropTypes from "prop-types";
const SuggestionBubble = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className + " suggestion-bubble",
    onClick: props.onClick
  }, props.suggestion);
};
SuggestionBubble.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  suggestion: PropTypes.string
};
export default SuggestionBubble;